<template>
    <div class="row pb-5">
        <div :class="[sidebyside ? 'col-lg-6' : 'col-lg-12']">
            <a href="https://app.azurity.nl/account/register/client" target="_blank" class="btn btn-azure btn-wide btn-lg mb-3" aria-label="Aanmelden als opdrachtgever">
                <span>Aanmelden als <br /> opdrachtgever</span>
                <div class="btn-icon">
                    <span>&rarr;</span>
                </div>
            </a>
        </div>
        <div :class="[sidebyside ? 'col-lg-6' : 'col-lg-12']">
            <register-button-pro :type="type"></register-button-pro>
        </div>
    </div>
</template>

<script>
import RegisterButtonPro from '@/components/RegisterButtonPro';
export default {
    components: {
        RegisterButtonPro
    },
    props: {
        sidebyside: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: 'beveiliger'
        }
    }
}
</script>